module.exports = __webpack_public_path__ + "media/images/thank-3deeb4314a0999511e057567bc7aecbb.png";